/**
 * @generated SignedSource<<a25368c4593f03b38182aea270240770>>
 * @relayHash 8189ad731819be27e4e1872da7dc0004
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 10fc3ecefa18199dfbcf17859cbea5f76eab5ed105ca5811dac03b0d8a53fccc

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentNav3Query } from './PopupContentNav3Query.graphql';

const node: PreloadableConcreteRequest<PopupContentNav3Query> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "10fc3ecefa18199dfbcf17859cbea5f76eab5ed105ca5811dac03b0d8a53fccc",
    "metadata": {},
    "name": "PopupContentNav3Query",
    "operationKind": "query",
    "text": null
  }
};

export default node;
